import { useTranslation } from 'react-i18next';
import React, {useState, useEffect,Fragment} from 'react';
import { useNavigate,useParams } from "react-router-dom";
import apiRequest from '../../functions/api';
import { useMessage } from '../../context/message-context';
import LoadingComponent from '../LoadingComponent/LoadingComponent';
import {TextField, useTheme, Typography, Card, MenuItem, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button, Box,Hidden ,IconButton, Tooltip} from "@mui/material";
import Grid from '@mui/material/Grid'
import ResponsiveDialog from '../shared/components/ResponsiveDialog'
import {setColor2,pad} from "../../functions/default";
import EditIcon from '@mui/icons-material/Edit';
import MessageBox from "../shared/components/MessageBox";
import { SearchTextField } from '../lib';
function Projektstundenwoche(props) {
  const { t } = useTranslation();
    // Standardvariablen
    const {client, accessToken, admin, archiv,Reload} = props;
    const {showErrorMessage} = useMessage();
    const [isLoading, setIsLoading] = useState(false);
    const { antragid } = useParams();
    const navigate = useNavigate();
    const today=new Date().getFullYear().toString()+pad(new Date().getMonth()+1,2)+pad(new Date().getDate(),2);
    const theme=useTheme()
    //dsa
    //Arbeitsvariablen
    const [name,setName]=useState("");
    const [kw,setKw]=useState("");
    const [von,setVon]=useState("");
    const [bis,setBis]=useState("");
    const [kz,setKz]=useState([]);
    const [glz,setGlz]=useState([]);
    const [zr_offen,setZr_offen]=useState("");
    const [zr_offen_color,setZr_offen_color]=useState("");
    const [bem_ablehnung,setBem_ablehnung]=useState();
    const [az,setAz]=useState([]);
    const [vert,setVert]=useState([]);
    const [vert_stunden,setVert_stunden]=useState([]);
    const [stunden,setStunden]=useState([]);    
    const [projekt,setProjekt]=useState([]);
    const [akti_auswahl,setAkti_auswahl]=useState([]);
    const [kart_auswahl,setKart_auswahl]=useState([]);
    const [proj_vorh,setProj_vorh]=useState("");
    const [tage,setTage]=useState([]);
    const [pruef,setPruef]=useState([]);
    const [pruefind,setPruefind]=useState("");
    const [open,setOpen]=useState("");
    const [listepk,setListepk]=useState([]);
    const [abem,setAbem]=useState([]);
    const [openStunden,setOpenStunden]=useState(-1);
    const [openProjekt,setOpenProjekt]=useState(-1);
    const [filter,setFilter]=useState("");
    const [zukunft,setZukunft]=useState("");
    const [maxdat,setMaxdat]=useState("");
    const [messageBoxOpen, setMessageBoxOpen] = useState(false);
    const [messageBoxOpen2, setMessageBoxOpen2] = useState(false);
    const [messageBoxOpen3, setMessageBoxOpen3] = useState(false);
    const [messageBoxOpen4, setMessageBoxOpen4] = useState(false);
    const [delTyp,setDelTyp]=useState("")
    const [delKey,setDelKey]=useState("")
    const [delBez,setDelBez]=useState("")
    //Funktionen
    useEffect(() => {
        setIsLoading(true);
        const payload={
            "mandant": client,
            "program": (admin==="J")?"PPROJ3":"PPROJN",
            "statement": "ANTRAG", 
            "key" :antragid,
            "archiv":archiv,
        }
        const headers={
            "Authorization": "Bearer "+accessToken,
        }
        apiRequest('POST', 'daten', payload, headers, postAntrag);
        //eslint-disable-next-line
    }, []);
    const postAntrag=(response)=>{
        setIsLoading(false);
        if (response.status === 200) {
           setName(response.data.name);
           setKw(response.data.kw);
           setVon(response.data.von);
           setBis(response.data.bis);
           setKz(response.data.kz);
           setGlz(response.data.glz);
           setZr_offen(response.data.zr_offen);
           setBem_ablehnung(response.data.bem_ablehnung);
           setAz(response.data.az);
           setVert(response.data.vert);
           setVert_stunden(response.data.vert_stunden);
           setStunden(response.data.stunden);
           setProjekt(response.data.projekt);
           setAkti_auswahl(response.data.akti_auswahl);
           setKart_auswahl(response.data.kart_auswahl);
           setProj_vorh(response.data.proj_vorh);
           setTage(response.data.tage);
           setPruef(response.data.pruef);
           setPruefind(response.data.pruefind);
           setListepk(response.data.listepk);
           setAbem(response.data.abem);
           setZukunft(response.data.zukunft);
           setMaxdat(response.data.maxdat);
           setZr_offen_color(response.data.zr_offen_color);
           setOpen("");
           setOpenStunden(-1);
           setOpenProjekt(-1);
        } else {
            if (response) {
                showErrorMessage(response.data.message);
            } else {
                showErrorMessage(t("Keine Internetverbindung"));
            }
            navigate(-1)
        }
    }
    if (isLoading) {
        return <LoadingComponent />
    }
    function Aktion(aktion){
        if (aktion==="speichern"){
            Speichern();
        }
        if (aktion==="absenden"){
            Absenden();
        }
        if (aktion==="genehmigen"){
            Genehmigen();
        }
    }
    function Speichern(){
        setIsLoading(true);
        const payload={
            "mandant": client,
            "program": (admin==="J")?"PPROJ3":"PPROJN",
            "statement": "SPEICHERN", 
            "key" :antragid,
            "kz" : kz,
            "pruefind":pruefind,
            "pruef":pruef,
            "length":(stunden)?stunden.length.toString():"",
            "stunden":stunden,
            "projekt":projekt,
            "az":az,
            }
        const headers={
            "Authorization": "Bearer "+accessToken,
        }
        apiRequest('POST', 'daten', payload, headers, postSpeichern);
    }
    const messageBoxResult = (result) => {
        setMessageBoxOpen(false);
        if (result === 'YES') {
            const payload={
                "mandant": client,
                "program": (admin==="J")?"PPROJ3":"PPROJN",
                "statement": "ABSENDEN", 
                "key" :antragid,
                "kz" : kz,
                "pruefind":pruefind,
                "pruef":pruef,
                "length":(stunden)?stunden.length.toString():"",
                "stunden":stunden,
                "projekt":projekt,
                "az":az,
                }
            const headers={
                "Authorization": "Bearer "+accessToken,
            }
            apiRequest('POST', 'daten', payload, headers,postAbsenden);
        }
    }
    function Absenden(){
        if (zukunft!=="1" && today<=maxdat){
            showErrorMessage(t("Zeitraum noch nicht abgeschlossen! Sie können die Verteilung erst absenden, wenn die Woche abgeschlossen ist"))
            return
        }
        if (zukunft==="1" && today<=maxdat){
            setMessageBoxOpen(true);
            return
        }
        setIsLoading(true);
        const payload={
            "mandant": client,
            "program": (admin==="J")?"PPROJ3":"PPROJN",
            "statement": "ABSENDEN", 
            "key" :antragid,
            "kz" : kz,
            "pruefind":pruefind,
            "pruef":pruef,
            "length":(stunden)?stunden.length.toString():"",
            "stunden":stunden,
            "projekt":projekt,
            "az":az,
            }
        const headers={
            "Authorization": "Bearer "+accessToken,
        }
        apiRequest('POST', 'daten', payload, headers,postAbsenden);
    }
    function Genehmigen(){
        setIsLoading(true);
        const payload={
            "mandant": client,
            "program": (admin==="J")?"PPROJ3":"PPROJN",
            "statement": "ABSENDEN", 
            "key" :(antragid.substr(0,4)==="vorg"?antragid.substr(4):antragid),
            "kz" : kz,
            "pruefind":pruefind,
            "pruef":pruef,
            "length":(stunden)?stunden.length.toString():"",
            "stunden":stunden,
            "projekt":projekt,
            "az":az,
            }
        const headers={
            "Authorization": "Bearer "+accessToken,
        }
        apiRequest('POST', 'daten', payload, headers,postAbsenden);
    }
    const postSpeichern=(response)=>{
        setIsLoading(false);
        if (response.status === 200) {
            if (response.data.message==="OK"){
                setName(response.data.name);
                setKw(response.data.kw);
                setVon(response.data.von);
                setBis(response.data.bis);
                setKz(response.data.kz);
                setGlz(response.data.glz);
                setZr_offen(response.data.zr_offen);
                setBem_ablehnung(response.data.bem_ablehnung);
                setAz(response.data.az);
                setVert(response.data.vert);
                setVert_stunden(response.data.vert_stunden);
                setStunden(response.data.stunden);
                setProjekt(response.data.projekt);
                setAkti_auswahl(response.data.akti_auswahl);
                setKart_auswahl(response.data.kart_auswahl);
                setProj_vorh(response.data.proj_vorh);
                setTage(response.data.tage);
                setPruef(response.data.pruef);
                setPruefind(response.data.pruefind);
                setListepk(response.data.listepk);
                setAbem(response.data.abem);
                setZukunft(response.data.zukunft);
                setMaxdat(response.data.maxdat);
                setZr_offen_color(response.data.zr_offen_color);
                setOpen("");
                setOpenStunden(-1);
                setOpenProjekt(-1);
            }
            else {
                showErrorMessage(response.data.message)
            }
        } else {
            if (response) {
                showErrorMessage(response.data.message);
            } else {
                showErrorMessage(t("Keine Internetverbindung"));
            }
        }
    }
    const postAbsenden=(response)=>{
        setIsLoading(false);
        if (response.status === 200) {
            if (response.data.message==="OK"){
                //if (admin==="J"){navigate('/PPROJ3/PPROJN/')}else{navigate('/PPROJN/')}
                Reload()
                navigate(-1)
            }
            else {
                showErrorMessage(response.data.message)
            }
        } else {
            if (response) {
                showErrorMessage(response.data.message);
            } else {
                showErrorMessage(t("Keine Internetverbindung"));
            }
        }
    }
    function changeStunden(value,index,index2){
        var tmpliste=[...stunden];
        tmpliste[index].werte[index2].wert=value;
        setStunden(tmpliste);
    }
    function changeAkti(value,index){
        var tmpliste=[...projekt];
        tmpliste[index].akti_key=value;
        setProjekt(tmpliste);
    }
    function changeKart(value,index){
        var tmpliste=[...projekt];
        tmpliste[index].kart_key=value;
        setProjekt(tmpliste);
    }
    function Add(type){
        if (type==="P"){
            setOpen("P")
        }
        if (type==="K"){
            setOpen("K")
        }
    }
    const messageBoxResult2 = (result) => {
        setMessageBoxOpen2(false);
        if (result === 'YES') {
            setIsLoading(true);
            const payload={
                "mandant": client,
                "program": (admin==="J")?"PPROJ3":"PPROJN",
                "statement": "COPY", 
                "key" :antragid,
                "kz" : kz,
                "pruefind":pruefind,
                "pruef":pruef,
                "length":(stunden)?stunden.length.toString():"",
                "stunden":stunden,
                "projekt":projekt,
                "az":az,
                }
            const headers={
                "Authorization": "Bearer "+accessToken,
            }
            apiRequest('POST', 'daten', payload, headers,postSpeichern);
        }
    }
    function Copy(){
        setMessageBoxOpen2(true)
    }
    function Auswahl(key){
        setIsLoading(true);
        const payload={
            "mandant": client,
            "program": (admin==="J")?"PPROJ3":"PPROJN",
            "statement": "ADD", 
            "key" :antragid,
            "kz" : kz,
            "pruefind":pruefind,
            "pruef":pruef,
            "length":(stunden)?stunden.length.toString():"",
            "stunden":stunden,
            "projekt":projekt,
            "az":az,
            "add":key,
            }
        const headers={
            "Authorization": "Bearer "+accessToken,
        }
        apiRequest('POST', 'daten', payload, headers,postSpeichern);
        setDelTyp("")
        setDelKey("")
        setDelBez("")
    }
    const messageBoxResult3 = (result) => {
        setMessageBoxOpen3(false);
        if (result === 'YES') {
            var fehler=0
            stunden.forEach((item,index)=>{
                if (item.key===delKey){
                    item.werte.forEach((item2,index2)=>{
                        if (item2.wert!=="00:00") fehler=1
                    })
                }
            })
            if (fehler===1){
                setMessageBoxOpen4(true)
            } else {
                setIsLoading(true);
                const payload={
                    "mandant": client,
                    "program": (admin==="J")?"PPROJ3":"PPROJN",
                    "statement": "DEL", 
                    "key" :antragid,
                    "kz" : kz,
                    "pruefind":pruefind,
                    "pruef":pruef,
                    "length":(stunden)?stunden.length.toString():"",
                    "stunden":stunden,
                    "projekt":projekt,
                    "az":az,
                    "typ":delTyp,
                    "del":delKey,
                    }
                const headers={
                    "Authorization": "Bearer "+accessToken,
                }
                apiRequest('POST', 'daten', payload, headers,postSpeichern);
                setDelTyp("")
                setDelKey("")
                setDelBez("")
            }
        }
    }
    const messageBoxResult4 = (result) => {
        setMessageBoxOpen4(false);
        if (result === 'YES') {
            setIsLoading(true);
            const payload={
                "mandant": client,
                "program": (admin==="J")?"PPROJ3":"PPROJN",
                "statement": "DEL", 
                "key" :antragid,
                "kz" : kz,
                "pruefind":pruefind,
                "pruef":pruef,
                "length":(stunden)?stunden.length.toString():"",
                "stunden":stunden,
                "projekt":projekt,
                "az":az,
                "typ":delTyp,
                "del":delKey,
                }
            const headers={
                "Authorization": "Bearer "+accessToken,
            }
            apiRequest('POST', 'daten', payload, headers,postSpeichern);
        }
    }
    function Del(typ,key,bez){
        setDelTyp(typ)
        setDelKey(key)
        setDelBez(bez)
        setMessageBoxOpen3(true)
    }
    function onClick(typ,index){
        if (typ==="az"){
            setOpenStunden(-2);
        }
        if (typ==="vert_stunden"){
            setOpenStunden(-3);
        }
        if (typ==="vert"){
            setOpenStunden(-4);
        }
        if (typ==="stunden"){
            setOpenStunden(index);
        }
    }
    function  onClickP(index){
        setOpenProjekt(index);
    }
    function Abbrechen(){
        setOpenStunden(-1);
        setOpenProjekt(-1);
    }
    function Gleitzeit(){
        return(
            <Box p={2}>
            <Card>
            <Box p={2}>
                <Grid container justifyContent="center" spacing={2}>
                    <Grid item xs={12}>
                        <h4>{(kz.vorg==="J")?"Projektstundenverteilung von "+name+" für KW "+kw:"Projektstundenverteilung für KW "+kw}</h4>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TableContainer>
                        <Table size="small">
                            <TableBody>
                                <TableRow>
                                    <TableCell>
                                        <Typography>{t("Name")}</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography>{name}</Typography>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>
                                        <Typography>{t("Zeitraum")}</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography>{von+" - "+bis}</Typography>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                        </TableContainer>
                    </Grid>
                    
                        {kz.archiv!=="J"&&
                        <Grid item xs={12} sm={6}>
                        <TableContainer>
                        <Table size="small">
                            <TableBody>
                                <TableRow style={glz.vormonat_color&&glz.vormonat_color!==""?{backgroundColor:setColor2(glz.vormonat_color,"1"),}:{}}>
                                    <TableCell>
                                        <Typography>{"Gleitzeit Stand "+glz.vormonat_zr}</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography>{glz.vormonat}</Typography>
                                    </TableCell>
                                </TableRow>
                                <TableRow style={glz.aktmonat_color&&glz.aktmonat_color!==""?{backgroundColor:setColor2(glz.aktmonat_color,"1"),}:{}}>
                                    <TableCell>
                                        <Typography>{"Gleitzeit Stand "+glz.aktmonat_zr}</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography>{glz.aktmonat}</Typography>
                                    </TableCell>
                                </TableRow>
                                {(glz.mehrarbeit_zr&&glz.mehrarbeit_zr!=="")&&
                                <TableRow style={glz.mehrarbeit_color&&glz.mehrarbeit_color!==""?{backgroundColor:setColor2(glz.mehrarbeit_color,"1"),}:{}}>
                                    <TableCell>
                                        <Typography>{"Mehrarbeit Stand "+glz.mehrarbeit_zr}</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography>{glz.mehrarbeit}</Typography>
                                    </TableCell>
                                </TableRow>
                                }
                            </TableBody>
                        </Table>
                        </TableContainer>
                        </Grid>
                        }
                    
                    {(zr_offen==="J")&&
                        <Grid item xs={12}>
                            <Typography style={{backgroundColor:setColor2(zr_offen_color,"1"),}}>{t("!Zeitraum noch nicht abgeschlossen!")}</Typography>
                        </Grid>
                    }
                </Grid>
            </Box>
            </Card>   
            </Box>
        )
    }
    function Kommentar(){
        return(
            <Box p={2}>
                <Card>
                    <Box p={2}>
                    <Grid container justifyContent="center" spacing={2}>
                        <Grid item xs={12}>
                            <h4>{"Ablehnungskommentare"}</h4>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography>
                                {abem&&abem.length>0&&abem.map((item,index)=>{
                                    return(
                                        <Fragment>
                                            {item.wert}<br/>
                                        </Fragment>
                                    )
                                })}
                            </Typography>
                        </Grid>
                    </Grid>
                    </Box>
                </Card>
            </Box>
        )
    }
    function Stunden(){
        return(
            <Box p={2}>
            <Card>
            <Box p={2}>
                <Grid container justifyContent="center" spacing={2}>
                    <Grid item xs={12}>
                        <h4>{"Stundenverteilung"}</h4>
                    </Grid>
                    <Grid item xs={12}>
                    <TableContainer>
                        <Table style={{tableLayout:"fixed"}} size="small">
                            
                            <Hidden lgDown>
                                {(kz.archiv==="J"||kz.bl==="J"||kz.vorg==="J"||kz.status==="J")?
                                <colgroup>
                                    <col style={{width:'28%'}}/>
                                    <col style={{width:'9%'}}/>
                                    <col style={{width:'9%'}}/>
                                    <col style={{width:'9%'}}/>
                                    <col style={{width:'9%'}}/>
                                    <col style={{width:'9%'}}/>
                                    <col style={{width:'9%'}}/>
                                    <col style={{width:'9%'}}/>
                                    <col style={{width:'9%'}}/>
                                </colgroup>
                                :
                                <colgroup>
                                    <col style={{width:'30%'}}/>
                                    <col style={{width:'10%'}}/>
                                    <col style={{width:'10%'}}/>
                                    <col style={{width:'10%'}}/>
                                    <col style={{width:'10%'}}/>
                                    <col style={{width:'10%'}}/>
                                    <col style={{width:'10%'}}/>
                                    <col style={{width:'10%'}}/>
                                </colgroup>
                                }
                                
                            </Hidden>
                            
                            <TableHead>
                                <TableRow className="tabledesign">
                                    <TableCell>
                                        <Typography>{t("Projekte / Kostenstellen")}</Typography>
                                    </TableCell>    
                                    <Hidden lgDown>
                                    <TableCell align="center">
                                        <Typography>{tage.mo}</Typography>
                                    </TableCell>    
                                    <TableCell align="center">
                                        <Typography>{tage.di}</Typography>
                                    </TableCell>    
                                    <TableCell align="center">
                                        <Typography>{tage.mi}</Typography>
                                    </TableCell>    
                                    <TableCell align="center">
                                        <Typography>{tage.do}</Typography>
                                    </TableCell>    
                                    <TableCell align="center">
                                        <Typography>{tage.fr}</Typography>
                                    </TableCell>    
                                    <TableCell align="center">
                                        <Typography>{tage.sa}</Typography>
                                    </TableCell>    
                                    <TableCell align="center">
                                        <Typography>{tage.so}</Typography>
                                    </TableCell>
                                    {(kz.archiv==="J"||kz.bl==="J"||kz.vorg==="J"||kz.status==="J")&&
                                    <TableCell>
                                        <Typography></Typography>
                                    </TableCell>    
                                    }
                                    </Hidden>
                                    <Hidden lgUp>
                                        <TableCell></TableCell>   
                                    </Hidden>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow className="tabledesign">
                                    <TableCell  style={{backgroundColor:theme.palette.background.dim2,}}>
                                        <Typography>{t("Arbeitszeit")}</Typography>
                                    </TableCell>
                                    <Hidden lgDown>
                                    {az.map((item,index)=>{
                                        return(
                                        <TableCell align="center" style={item.color==="215215215"?{backgroundColor:theme.palette.background.dim2}:{backgroundColor:setColor2(item.color,"1")}}>
                                            <Tooltip title={item.wert}>
                                                <Typography style={{whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{item.wert}</Typography>
                                            </Tooltip>
                                        </TableCell>    
                                        )
                                    })}
                                    {(kz.archiv==="J"||kz.bl==="J"||kz.vorg==="J"||kz.status==="J")&&
                                    <TableCell>
                                        <Typography></Typography>
                                    </TableCell>
                                    }
                                    </Hidden>
                                    <Hidden lgUp>   
                                    <TableCell style={{backgroundColor:theme.palette.background.dim2,}}>
                                        <IconButton color="primary" onClick={()=>onClick("az",0)}>
                                            <EditIcon/>
                                        </IconButton>
                                    </TableCell>   
                                </Hidden>
                                </TableRow>
                                <TableRow className="tabledesign">
                                    <TableCell  style={{backgroundColor:theme.palette.background.dim2,}}>
                                        <Typography>{t("Verteilte Stunden")}</Typography>
                                    </TableCell>
                                    <Hidden lgDown>
                                    {vert_stunden.map((item,index)=>{
                                        return(
                                        <TableCell align="center" style={item.color==="215215215"?{backgroundColor:theme.palette.background.dim2}:{backgroundColor:setColor2(item.color,"1")}}> 
                                            <Tooltip title={item.wert}>
                                                <Typography style={{whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{item.wert}</Typography>
                                            </Tooltip>
                                        </TableCell>    
                                        )
                                    })}
                                    {(kz.archiv==="J"||kz.bl==="J"||kz.vorg==="J"||kz.status==="J")&&
                                    <TableCell>
                                        <Typography></Typography>
                                    </TableCell>
                                    }
                                    </Hidden>
                                    <Hidden lgUp>
                                    <TableCell style={{backgroundColor:theme.palette.background.dim2,}}>
                                        <IconButton color="primary" onClick={()=>onClick("vert_stunden",0)}>
                                            <EditIcon/>
                                        </IconButton>
                                    </TableCell>   
                                </Hidden>
                                </TableRow>
                                {(vert&&vert.length>0)&&
                                <TableRow  className="tabledesign">
                                    <TableCell style={{backgroundColor:theme.palette.background.dim2,}}>
                                        <Typography>{t("Noch zu verteilen")}</Typography>
                                    </TableCell>
                                    <Hidden lgDown>
                                    {vert.map((item,index)=>{
                                        return(
                                        <TableCell align="center" style={item.color==="215215215"?{backgroundColor:theme.palette.background.dim2}:{backgroundColor:setColor2(item.color,"1")}}>
                                            <Tooltip title={item.wert}>
                                                <Typography style={{whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{item.wert}</Typography>
                                            </Tooltip>
                                        </TableCell>    
                                        )
                                    })}
                                    {(kz.archiv==="J"||kz.bl==="J"||kz.vorg==="J"||kz.status==="J")&&
                                    <TableCell>
                                        <Typography></Typography>
                                    </TableCell>
                                    }
                                    </Hidden>
                                    <Hidden lgUp>
                                    <TableCell style={{backgroundColor:theme.palette.background.dim2,}}>
                                        <IconButton color="primary" onClick={()=>onClick("vert",0)}>
                                            <EditIcon/>
                                        </IconButton>
                                    </TableCell>   
                                </Hidden>
                                </TableRow>
                                }
                                {(stunden&&stunden.length>0)&&stunden.map((item,index)=>{
                                    return(
                                    <TableRow className="tabledesign">
                                    <Hidden lgDown>
                                    <TableCell>
                                        <Typography>{item.bez}</Typography>
                                    </TableCell>
                                    {(item.werte&&item.werte.length>1)&&item.werte.map((item2,index2)=>{
                                        return(
                                        <TableCell align="center">
                                            <TextField
                                                disabled={(kz.archiv==="J"||(kz.bl==="J"&&kz.an==="J"))}
                                                type="time"
                                                variant="outlined"
                                                size="small"
                                                value={item2.wert}
                                                onChange={(e)=>changeStunden(e.target.value,index,index2)}
                                            />
                                        </TableCell>    
                                        )
                                    })}
                                    {(kz.archiv==="J"||kz.bl==="J"||kz.vorg==="J"||kz.status==="J")&&
                                    <TableCell>
                                        <Typography>{item.status}</Typography>
                                    </TableCell>
                                    }
                                    </Hidden>
                                    <Hidden lgUp>
                                    <TableCell>
                                        <Typography>{item.keybez}<br/>{item.bes}</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <IconButton color="primary" onClick={()=>onClick("stunden",index)}>
                                            <EditIcon/>
                                        </IconButton>
                                    </TableCell>   
                                </Hidden>
                                    </TableRow>
                                    )
                                })}
                            </TableBody>
                        </Table>
                        </TableContainer>
                    </Grid>
                    {(kz.archiv!=="J"&&(kz.bl!=="J"||kz.an!=="J"))&&
                    <Fragment>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        {(kz.vorg==="J")&&
                        <Button
                            variant="contained"
                            fullWidth
                            onClick={() => Aktion("genehmigen")}
                            color="primary"
                        >
                            {t("Genehmigen")}
                        </Button>
                        }
                        {(kz.vorg!=="J")&&
                        <Button
                            variant="contained"
                            fullWidth
                            onClick={() => Aktion("absenden")}
                            color="primary"
                        >
                            {t("Absenden")}
                        </Button>
                        }
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Button
                            variant="contained"
                            fullWidth
                            onClick={() => Aktion("speichern")}
                            color="primary"
                        >
                            {"Speichern und Aktualisieren"}
                        </Button>
                    </Grid>
                    </Fragment>
                    }
                </Grid>
            </Box>
            </Card>   
            </Box>
        )
    }
    function Projekte(){
        return(
            <Box p={2}>
            <Card>
            <Box p={2}>
                <Grid container justifyContent="center" spacing={2}>
                    <Grid item xs={12}>
                        <h4>{"Projektverteilung"}</h4>
                    </Grid>
                    <Grid item xs={12}>
                    <TableContainer>
                        <Table size="small">
                            <TableHead>
                                <TableRow className="tabledesign">
                                    <Hidden lgDown>
                                    <TableCell className="tabledesign">
                                        <Typography>{t("Projekt / Kostenstelle")}</Typography>
                                    </TableCell>
                                    <TableCell className="tabledesign">
                                        <Typography>{t("Beschreibung")}</Typography>
                                    </TableCell>
                                    {(kz.akti==="J")&&
                                    <TableCell>
                                        <Typography>{t("Aktivität")}</Typography>
                                    </TableCell>
                                    }
                                    {(kz.kart==="J")&&
                                    <TableCell >
                                        <Typography>{t("Kostenart")}</Typography>
                                    </TableCell>
                                    }
                                    {(kz.grp==="J")&&
                                    <TableCell >
                                        <Typography>{t("Gruppe")}</Typography>
                                    </TableCell>
                                    }
                                    {(kz.zus==="J")&&
                                    <TableCell >
                                        <Typography>{t("Zusatz")}</Typography>
                                    </TableCell>
                                    }
                                    {(kz.archiv!=="J"&&(kz.bl!=="J"||kz.an!=="J"))&&
                                    <TableCell>
                                        <Typography></Typography>
                                    </TableCell>
                                    }
                                    </Hidden>
                                    <Hidden lgUp>
                                        <TableCell >
                                            <Typography>{t("Projekt / Kostenstelle")}</Typography>
                                        </TableCell>
                                        <TableCell></TableCell>
                                    </Hidden>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {(projekt&&projekt.length>0)&&projekt.map((item,index)=>{
                                    return(
                                        <TableRow className="tabledesign">
                                            <Hidden lgDown>
                                            <TableCell className="tabledesign">
                                                <Typography>{item.keybez}</Typography>
                                            </TableCell>
                                            <TableCell className="tabledesign">
                                                <Typography>{item.bez}</Typography>
                                            </TableCell>
                                            {(kz.akti==="J")&&
                                            <TableCell >
                                                {(item.typ==="P")&&
                                                <TextField
                                                    select
                                                    fullWidth
                                                    variant="outlined"
                                                    size="small"
                                                    disabled={(kz.archiv==="J"||(kz.bl==="J"&&kz.an==="J"))}
                                                    value={item.akti_key}
                                                    onChange={(e)=>changeAkti(e.target.value,index)}
                                                >
                                                    {akti_auswahl.map((item2,index2)=>{
                                                        return(
                                                        <MenuItem key={index2} value={item2.key}>{item2.bez}</MenuItem>
                                                        )
                                                    })}
                                                </TextField>
                                                }
                                            </TableCell>
                                            }
                                            {(kz.kart==="J")&&
                                            <TableCell>
                                                {(item.typ==="P")&&
                                                <TextField
                                                    select
                                                    fullWidth
                                                    variant="outlined"
                                                    size="small"
                                                    disabled={(kz.archiv==="J"||(kz.bl==="J"&&kz.an==="J"))}
                                                    value={item.kart_key}
                                                    onChange={(e)=>changeKart(e.target.value,index)}
                                                >
                                                    {kart_auswahl.map((item2,index2)=>{
                                                        return(
                                                        <MenuItem key={index2} value={item2.key}>{item2.bez}</MenuItem>
                                                        )
                                                    })}
                                                </TextField>
                                                }
                                            </TableCell>
                                            }
                                            {(kz.grp==="J")&&
                                            <TableCell >
                                                <Typography>{item.grp}</Typography>
                                            </TableCell>
                                            }
                                            {(kz.zus==="J")&&
                                            <TableCell> 
                                                <Typography>{item.zus}</Typography>
                                            </TableCell>
                                            }
                                            {(kz.archiv!=="J"&&(kz.bl!=="J"||kz.an!=="J"))&&
                                            <TableCell>
                                                <Button 
                                                    variant="contained"
                                                    fullWidth
                                                    onClick={() => Del(item.typ,item.key,item.bez)}
                                                    color="primary"
                                                >
                                                    {item.typ==="K"?"Kostenstelle löschen":"Projekt löschen"}
                                                </Button>
                                            </TableCell>
                                            }
                                            </Hidden>
                                            <Hidden lgUp>
                                                <TableCell>
                                                    {item.keybez}<br/>{item.bez}
                                                </TableCell>
                                                <TableCell>
                                                    <IconButton color="primary" onClick={()=>onClickP(index)}>
                                                        <EditIcon/>
                                                    </IconButton>
                                                </TableCell>   
                                            </Hidden>
                                        </TableRow>
                                    )
                                })}
                            </TableBody>
                        </Table>
                        </TableContainer>
                    </Grid>
                    {(kz.archiv!=="J"&&(kz.bl!=="J"||kz.an!=="J"))&&
                    <Fragment>
                    {(proj_vorh==="J")&&
                    <Grid item xs={12} sm={6} md={4}>
                        <Button
                            variant="contained"
                            fullWidth
                            onClick={() => Add("P")}
                            color="primary"
                        >
                            {t("Neues Projekt hinzufügen")}
                        </Button>
                    </Grid>
                    }
                    {(proj_vorh==="J")&&
                    <Grid item xs={12} sm={6} md={4}>
                        <Button
                            variant="contained"
                            fullWidth
                            onClick={() => Add("K")}
                            color="primary"
                        >
                            {t("Neue Kostenstelle hinzufügen")}
                        </Button>
                    </Grid>
                    }
                    {(kz.an==="J")&&
                    <Grid item xs={12} sm={6} md={4}>
                        <Button
                            variant="contained"
                            fullWidth
                            onClick={() => Copy("K")}
                            color="primary"
                        >
                            {t("Projekte aus Vorwoche kopieren")}
                        </Button>
                    </Grid>
                    }
                    </Fragment>
                    }
                </Grid>
            </Box>
            </Card>   
            </Box>
        )
    }
    function AddProjekt(){
        return(
        <ResponsiveDialog 
          title={open==="P"?"Projekt auswählen" :"Kostenstelle auswählen"}
          open={open==="P"||open==="K"} 
          setOpen={(o) => {setOpen(o);setFilter("")}}
        >
            <Box p={2}>
                <SearchTextField
                            fullWidth
                            label={t("Suche")}
                            id="filter2"
                            variant="outlined"
                            value={filter}
                            inputProps={{
                            autoCapitalize: 'off',
                            autoCorrect: 'off',
                            spellCheck: 'false',
                            autoComplete: 'off'
                            }}
                            onChange={(e)=>setFilter(e.target.value)}
                        />
                </Box>
            <TableContainer>
            <Table>
                <TableBody>
                    {(listepk&&listepk.length>0)&&listepk.filter((item) =>{
                        if (item.typ!==open) return false;
                        if (item.kenn.toLowerCase().includes(filter.toLowerCase())===true) return true;
                        if (item.bez.toLowerCase().includes(filter.toLowerCase())===true) return true;
                        if (item.leiter.toLowerCase().includes(filter.toLowerCase())===true) return true;
                        if (item.leiter.toLowerCase().includes(filter.toLowerCase())===true) return true;
                        if (item.gruppe&&item.gruppe!==""&&item.gruppe.toLowerCase().includes(filter.toLowerCase())===true) return true;
                        if (item.zusatz&&item.zusatz!==""&&item.zusatz.toLowerCase().includes(filter.toLowerCase())===true) return true;
                        return false;
                    }).map((item)=>{
                        console.log(item)
                        return(
                        <TableRow
                            style={{cursor: 'pointer'}}
                            onClick={() => Auswahl(item.key) }
                            hover
                        >
                            <TableCell>
                                {"Kennung: "+item.kenn}<br/>{"Bezeichnung: "+item.bez}<br/>{"Leiter: "+item.leiter}{(item.gruppe&&item.gruppe!=="")&&<br/>+"Gruppe: "+item.gruppe}{(item.zusatz&&item.zusatz!=="")&&<br/>+"Titelnummer: "+item.zusatz}
                            </TableCell>
                        </TableRow>
                        )
                    })}
                    {(!listepk||listepk.length<=0)&&
                        <TableRow><TableCell>{t("Es stehen keine weiteren Projekte/Kostenstellen zur Auswahl")}</TableCell></TableRow>
                    }
                </TableBody>
            </Table>
            </TableContainer>
        </ResponsiveDialog>
        )
    }
    function StundenAnzeige(){
        return(
            <ResponsiveDialog 
              title={t("KW ")+kw+" - "+name}
              open={openStunden!==-1} 
              setOpen={(o) => setOpenStunden(-1)}
              actionButton={
                <Button color="primary" onClick={() => Abbrechen()}>{t("Zurück")}</Button>
              }
            >
                <Grid container spacing={2} justifyContent="center" alignItems="flex-end">
                <Grid item xs={12}>
                <Box p={2}>
                    <Grid container justifyContent="center" spacing={2}>
                    <Grid item xs={12}>
                        <TextField
                            style={(openStunden<-1)?{backgroundColor:theme.palette.background.dim2,}:{}}
                            id={"proj"}
                            disabled
                            value={(openStunden===-2)?"Arbeitszeit":(openStunden===-3)?"Verteilte Stunden":(openStunden===-4)?"Noch zu verteilende Stunden":(openStunden>-1)?stunden[openStunden].keybez:""}
                            variant="outlined"
                            fullWidth
                            label={t("Projekt/Kostenstelle")}
                        />
                    </Grid>
                    </Grid>
                    {openStunden>-1&&
                    <Grid container justifyContent="center" spacing={2}>
                    <Grid item xs={12}>
                        <TextField
                            id={"proj"}
                            disabled
                            value={(openStunden>-1)?stunden[openStunden].bes:""}
                            variant="outlined"
                            fullWidth
                            label={t("Beschreibung")}
                        />
                    </Grid>
                    </Grid>
                    }
                    {openStunden===-2&&
                        <Fragment>
                            {az.map((item,index)=>{
                                return(
                                    <Grid container justifyContent="center" spacing={2}>
                                    <Grid item xs={12}>
                                        <TextField
                                            style={item.color==="215215215"?{backgroundColor:theme.palette.background.dim2}:{backgroundColor:setColor2(item.color,"1")}}
                                            id={"az"+index.toString()}
                                            disabled
                                            value={item.wert}
                                            variant="outlined"
                                            fullWidth
                                            label={tage["ind"+index.toString()]}
                                        />
                                    </Grid>
                                    </Grid>
                                )
                            })}
                        </Fragment>
                    }
                    {openStunden===-3&&
                        <Fragment>
                            {vert_stunden.map((item,index)=>{
                                return(
                                    <Grid container justifyContent="center" spacing={2}>
                                    <Grid item xs={12}>
                                        <TextField
                                            style={item.color==="215215215"?{backgroundColor:theme.palette.background.dim2}:{backgroundColor:setColor2(item.color,"1")}}
                                            id={"vert_stunden"+index.toString()}
                                            disabled
                                            value={item.wert}
                                            variant="outlined"
                                            fullWidth
                                            label={tage["ind"+index.toString()]}
                                        />
                                    </Grid>
                                    </Grid>
                                )
                            })}
                        </Fragment>
                    }
                    {openStunden===-4&&
                        <Fragment>
                            {vert.map((item,index)=>{
                                return(
                                    <Grid container justifyContent="center" spacing={2}>
                                    <Grid item xs={12}>
                                        <TextField
                                            style={item.color==="215215215"?{backgroundColor:theme.palette.background.dim2}:{backgroundColor:setColor2(item.color,"1")}}
                                            id={"vert"+index.toString()}
                                            disabled
                                            value={item.wert}
                                            variant="outlined"
                                            fullWidth
                                            label={tage["ind"+index.toString()]}
                                        />
                                    </Grid>
                                    </Grid>
                                )
                            })}
                        </Fragment>
                    }
                    {openStunden>-1&&
                        <Fragment>
                            {stunden[openStunden].werte.map((item,index)=>{
                                return(
                                <Fragment>
                                    <Grid container justifyContent="center" spacing={2}>
                                    <Grid item xs={12}>
                                        <TextField
                                            disabled={(kz.archiv==="J"||(kz.bl==="J"&&kz.an==="J"))}
                                            type="time"
                                            variant="outlined"
                                            onChange={(e)=>changeStunden(e.target.value,openStunden,index)}
                                            id={"stunden"+index.toString()}
                                            fullWidth
                                            value={item.wert}
                                            label={tage["ind"+index.toString()]}
                                        />
                                    </Grid>
                                    </Grid>
                                </Fragment>
                                )
                            })}
                            <Grid container justifyContent="center" spacing={2}>
                                <Grid item xs={12}>
                                    {(kz.archiv==="J"||kz.bl==="J"||kz.vorg==="J"||kz.status==="J")&&
                                        <TextField
                                        disabled
                                        variant="outlined"
                                        id={"status"}
                                        fullWidth
                                        value={stunden[openStunden].status}
                                        label={"Status"}
                                        />
                                    }
                                </Grid>
                                </Grid>
                        </Fragment>
                    }
                </Box>
                </Grid>
                </Grid>
            </ResponsiveDialog>
        )
    }
    function ProjektAnzeige(){
        return(
                <ResponsiveDialog 
                  title={t("KW ")+kw+" - "+name}
                  open={openProjekt!==-1} 
                  setOpen={(o) => setOpenProjekt(-1)}
                  actionButton={
                    <Button color="primary" onClick={() => Abbrechen()}>{t("Zurück")}</Button>
                  }
                >
                    <Grid container spacing={2} justifyContent="center" alignItems="flex-end">
                    <Grid item xs={12}>
                    <Box p={2}>
                        <Grid container justifyContent="center" spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                id={"proj_key"}
                                disabled
                                value={(openProjekt>-1&&projekt[openProjekt])?projekt[openProjekt].keybez:""}
                                variant="outlined"
                                fullWidth
                                label={t("Projekt/Kostenstelle")}
                            />
                        </Grid>
                        </Grid>
                        <Grid container justifyContent="center" spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                id={"proj_bez"}
                                disabled
                                value={(openProjekt>-1&&projekt[openProjekt])?projekt[openProjekt].bez:""}
                                variant="outlined"
                                fullWidth
                                label={t("Beschreibung")}
                            />
                        </Grid>
                        </Grid>
                        {(kz.akti==="J"&&openProjekt>-1&&projekt[openProjekt]&&projekt[openProjekt].typ==="P")&&
                        <Grid container justifyContent="center" spacing={2}>
                        <Grid item xs={12}>
                        <TextField
                            select
                            fullWidth
                            variant="outlined"
                            disabled={(kz.archiv==="J"||(kz.bl==="J"&&kz.an==="J"))}
                            value={(openProjekt>-1&&projekt[openProjekt])?projekt[openProjekt].akti_key:""}
                            onChange={(e)=>changeAkti(e.target.value,openProjekt)}
                            label={t("Aktivität")}
                        >
                            {akti_auswahl.map((item2,index2)=>{
                                return(
                                    <MenuItem key={index2} value={item2.key}>{item2.bez}</MenuItem>
                                )
                            })}
                        </TextField>
                        </Grid>
                        </Grid>                  
                        }
                        {(kz.kart==="J"&&openProjekt>-1&&projekt[openProjekt]&&projekt[openProjekt].typ==="P")&&
                        <Grid container justifyContent="center" spacing={2}>
                        <Grid item xs={12}>
                        <TextField
                            select
                            fullWidth
                            variant="outlined"
                            disabled={(kz.archiv==="J"||(kz.bl==="J"&&kz.an==="J"))}
                            value={(openProjekt>-1&&projekt[openProjekt])?projekt[openProjekt].kart_key:""}
                            onChange={(e)=>changeKart(e.target.value,openProjekt)}
                            label={t("Kostenart")}
                        >
                            {kart_auswahl.map((item2,index2)=>{
                                return(
                                    <MenuItem key={index2} value={item2.key}>{item2.bez}</MenuItem>
                                )
                            })}                   
                        </TextField>
                        </Grid>
                        </Grid>
                        }
                        {(kz.grp==="J")&&
                        <Grid container justifyContent="center" spacing={2}>
                        <Grid item xs={12}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            disabled
                            value={(openProjekt>-1&&projekt[openProjekt])?projekt[openProjekt].grp:""}
                            label={t("Gruppe")}
                        />
                        </Grid>
                        </Grid>
                        }
                        {(kz.zus==="J")&&
                        <Grid container justifyContent="center" spacing={2}>
                        <Grid item xs={12}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            disabled
                            value={(openProjekt>-1&&projekt[openProjekt])?projekt[openProjekt].zus:""}
                            label={t("Zusatz")}
                        />
                        </Grid>
                        </Grid>
                        }
                        {(kz.archiv!=="J"&&(kz.bl!=="J"||kz.an!=="J"))&&
                        <Grid container justifyContent="center" spacing={2}>
                        <Grid item xs={12}>              
                        <Button 
                            variant="contained"
                            fullWidth
                            onClick={() => (openProjekt>-1)&&Del(projekt[openProjekt].typ,projekt[openProjekt].key,projekt[openProjekt].bez)}
                            color="primary"
                        >
                            {(openProjekt>-1&&projekt[openProjekt].typ==="K")?"Kostenstelle löschen":"Projekt löschen"}
                        </Button>
                        </Grid>
                        </Grid>
                        }
                    </Box>
                    </Grid>
                    </Grid>
                </ResponsiveDialog>
        )
    }
    //Rueckgabe
    return(
        <Fragment>
            <Grid container justifyContent="center" spacing={2}>
                {AddProjekt()}
                {StundenAnzeige()}
                {ProjektAnzeige()}
                <Grid item xs={12} md={8}>
                    {Gleitzeit()}
                </Grid>
                {bem_ablehnung&&bem_ablehnung!==""&&
                <Grid item xs={12} md={8}>
                    {Kommentar()}
                </Grid>
                }
                <Grid item xs={12} >
                    {Stunden()}
                </Grid>
                <Grid item xs={12} >
                    {Projekte()}
                </Grid>
            </Grid>
            <MessageBox 
                open={messageBoxOpen}
                handleResponse={messageBoxResult}
                buttons="YESNO"
                text={t("Zeitraum noch nicht abgeschlossen! Sind Sie sicher, dass Sie die Verteilung absenden möchten?")}
                title={t("Hinweis")}
                onClose={() => setMessageBoxOpen(false)}
            />
            <MessageBox 
                open={messageBoxOpen2}
                handleResponse={messageBoxResult2}
                buttons="YESNO"
                text={t("Achtung!!! Durch diese Aktion wird die Projektauswahl der Vorwoche in die aktuelle Woche übernommen. Dabei werden ggf. Projekte aus der Auswahl der aktuellen Woche entfernt. Möchten Sie trotzdem fortfahren?")}
                title={t("Hinweis")}
                onClose={() => setMessageBoxOpen2(false)}
            />
            <MessageBox 
                open={messageBoxOpen3}
                handleResponse={messageBoxResult3}
                buttons="YESNO"
                text={t("Sind Sie sicher, dass Sie das Projekt aus Ihrer Projektverwaltung löschen möchten?")}
                title={t("Hinweis")}
                onClose={() => setMessageBoxOpen3(false)}
            />
            <MessageBox 
                open={messageBoxOpen4}
                handleResponse={messageBoxResult4}
                buttons="YESNO"
                text={"In "+delKey+" - "+delBez+" wurden bereits Zeiten verteilt. Möchten Sie es wirklich löschen?"}
                title={t("Hinweis")}
                onClose={() => setMessageBoxOpen4(false)}
            />
        </Fragment>
    )
}
export default Projektstundenwoche;
